export default {
  name: 'atmosphere',
  key: 'atmosphere',
  attributes: {
    corrosive: {
      key: 'corrosive',
      name: 'atmosphere.corrosive',
    },
    inert: {
      key: 'inert',
      name: 'atmosphere.inert',
    },
    airlessThin: {
      key: 'airlessThin',
      name: 'atmosphere.airlessThin',
    },
    breathable: {
      key: 'breathable',
      name: 'atmosphere.breathable',
    },
    thick: {
      key: 'thick',
      name: 'atmosphere.thick',
    },
    invasive: {
      key: 'invasive',
      name: 'atmosphere.invasive',
    },
    corrosiveInvasive: {
      key: 'corrosiveInvasive',
      name: 'atmosphere.corrosiveInvasive',
    },
  },
};
